import { useEffect, useRef } from 'react';

// Single toast item. Uses .lk-toast + .lk-toast--{tone} classes (see patterns.css).
// Dismiss on click, auto-dismiss handled by ToastProvider.
export function Toast({ id, msg, tone = 'info', onDismiss, action }) {
  const btnRef = useRef(null);

  // For "danger" we escalate a11y-assertiveness at the wrapper level via aria-live;
  // here we just ensure the dismiss button is reachable.
  useEffect(() => {
    // no-op; placeholder for future focus-management when a destructive toast appears
  }, []);

  const toneCls =
    tone === 'success' ? 'lk-toast--success'
    : tone === 'danger' || tone === 'error' ? 'lk-toast--danger'
    : 'lk-toast--info';

  return (
    <div className={`lk-toast ${toneCls}`} role="status">
      <div className="lk-toast__msg">{msg}</div>
      <div className="lk-toast__actions">
        {action ? (
          <button
            type="button"
            className="lk-btn lk-btn--ghost lk-btn--sm"
            onClick={() => {
              try { action.onClick?.(); } finally { onDismiss?.(id); }
            }}
          >
            {action.label}
          </button>
        ) : null}
        <button
          ref={btnRef}
          type="button"
          className="lk-toast__close"
          aria-label="Закрыть уведомление"
          onClick={() => onDismiss?.(id)}
        >
          ×
        </button>
      </div>
    </div>
  );
}

export default Toast;
